<p-toast position="bottom-right"></p-toast>

<p-dialog
    [(visible)]="displayAgregarOpcionDialog"
    [style]="{ width: '500px' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="onAgregarOpcionDialogClosed()"
    header="Agregar Nueva Opción"
>
    <app-agregar-opcion-form 
        [opcion]="nuevaOpcion" 
        [campoPadre]="model?.descripcion || ''"
        (onSave)="onAgregarOpcionSaved($event)">
    </app-agregar-opcion-form>
</p-dialog>

<form [formGroup]="form" (ngSubmit)="model ? update() : create()" appPermissionControl="P267F0001">
    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="descripcion" class="form-control" 
                [placeholder]="'Ingrese nombre del campo'" 
                [disabled]="model" appPermissionControl="P267K0001">
            <label>Campo</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <p-dropdown 
                formControlName="caracteristica" 
                [options]="caracteristicasOptions" 
                optionLabel="label" 
                appendTo="body"
                optionValue="value"
                [filter]="true"
                placeholder="Seleccione una característica"
                class="w-100" appPermissionControl="P267K0002">
            </p-dropdown>
            <label>Característica</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="model ? update() : create()"
            [disabled]="!form.valid || loading" appPermissionControl="P267B0001">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
        <button *ngIf="model" mat-flat-button class="btn-new btn-menu" type="button" (click)="openAgregarOpcionDialog()" appPermissionControl="P267B0002">
            <mat-icon>add</mat-icon>
            Nuevo
        </button>
    </div>
</form>

<!-- Tabla de opciones (solo visible en modo edición) -->
<div *ngIf="model" class="table-section mt-4">    
    <p-table
        [value]="opcionesCreadas" 
        [paginator]="true" 
        [rows]="5"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[5, 10, 20]"
        [scrollable]="true"
        [scrollHeight]="'200px'"
        styleClass="p-datatable-gridlines"
        [resizableColumns]="true"
        [autoLayout]="true"
        responsiveLayout="scroll"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} opciones"
     appPermissionControl="P267T0001">
        <ng-template pTemplate="header">
            <tr>
                <th class="th-prime" appPermissionControl="P267C0001">Opción</th>
                <th class="th-prime" style="width: 100px;" appPermissionControl="P267C0002">Acción</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-opcion>
            <tr>
                <td class="td-prime">{{ opcion }}</td>
                <td class="td-prime">
                    <div class="d-flex gap-2 justify-content-center">
                        <button
                            pButton
                            icon="pi pi-trash"
                            class="p-button-rounded p-button-danger p-button-text"
                            (click)="eliminarOpcion(opcion)"
                            pTooltip="Eliminar"
                         appPermissionControl="P267B0003"></button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="2" class="text-center td-prime">
                    <span>No hay opciones creadas</span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>